import type { IExtractRouteParamMap } from "../types";
import { createPaths } from "../utils";

const baseRoute = `/support`;

export const supportRoutesObj = {
  home: baseRoute,
} as const;

export type ISupportRouteParams = IExtractRouteParamMap<
  typeof supportRoutesObj
>;

export const supportPath = createPaths<
  typeof supportRoutesObj,
  ISupportRouteParams
>(supportRoutesObj);
